// extracted by mini-css-extract-plugin
export default {"linkContainer":"UfEAtHyRBZ712_lLBZSZ"};